<script setup lang="ts">
import ChipStack from './ChipStack.vue'

defineOptions({
  inheritAttrs: false
})

withDefaults(
  defineProps<{
    smallBlind?: number
    value: number | string | null
    variant?: 'light' | 'dark'
    layout?: 'horizontal' | 'vertical'
  }>(),
  {
    smallBlind: 10,
    layout: 'horizontal',
    variant: 'dark'
  }
)

const CHIP_SELECTOR = '.chip-stack__stack-chip'

// TODO: refactor these hardcoded values to sync with ChipStack.vue CSS automatically
// From CSS transition-duration: 0.15s for CHIP_SELECTOR in ChipStack.vue
const CHIP_DURATION = 150

// From CSS transition-delay: 500ms for CHIP_SELECTOR:nth-child(1) in ChipStack.vue
const MAX_CHIP_DELAY = 500

let deltaLeft = 0
let deltaTop = 0

function beforeLeave(el: Element) {
  // Where to fly?
  const target = document.querySelector('.table__pots')! as HTMLElement
  const {
    offsetParent: targetOffsetParent,
    offsetLeft: targetOffsetLeft,
    offsetTop: targetOffsetTop
  } = target

  let currentNode = el.querySelector(CHIP_SELECTOR)! as HTMLElement
  let currentLeft = 0
  let currentTop = 0

  while (currentNode !== targetOffsetParent) {
    currentLeft += currentNode.offsetLeft
    currentTop += currentNode.offsetTop
    currentNode = currentNode.offsetParent as HTMLElement
  }

  deltaLeft = currentLeft - targetOffsetLeft
  deltaTop = currentTop - targetOffsetTop
  ;[...el.querySelectorAll(CHIP_SELECTOR)].forEach((rawEl: Element) => {
    const currentEl = rawEl as HTMLElement
    currentEl.style.left = `${currentEl.offsetLeft}px`
    currentEl.style.top = `${currentEl.offsetTop}px`
    currentEl.style.opacity = '1'
  })
}

function onLeave(el: Element, done: () => void) {
  const chips = [...el.querySelectorAll(CHIP_SELECTOR)]
  if (!chips.length) {
    return setTimeout(done)
  }

  chips.forEach((rawEl: Element, idx) => {
    const currentEl = rawEl as HTMLElement

    currentEl.style.left = `${currentEl.offsetLeft - deltaLeft}px`
    currentEl.style.top = `${currentEl.offsetTop - deltaTop}px`
    currentEl.style.opacity = '0'

    if (idx === chips.length - 1) {
      currentEl.addEventListener('transitionend', done)

      // Fallback in case 'transitionend' doesn’t fire
      const EXTRA_DELAY = 100
      const timeout = CHIP_DURATION * chips.length + MAX_CHIP_DELAY + EXTRA_DELAY
      setTimeout(done, timeout)
    }
  })
}
const id = Math.random()
</script>

<template>
  <transition name="player-stack" :css="false" @before-leave="beforeLeave" @leave="onLeave">
    <chip-stack
      v-if="value"
      :key="`stack-${id}`"
      v-bind="{ ...$attrs, ...$props }"
      player-id="playerId"
      :variant="variant"
      :layout="layout"
    />
  </transition>
</template>
